const overrides = (palette, typography) => ({
  root: {},
  notchedOutline: {
    borderColor: palette.action.selected
  }
})

export default overrides
